import "../TripSummary/tripSummary.css";
import { useEffect, useState } from "react";
import { withRouter, useParams, NavLink, Link } from "react-router-dom";
import { connect } from "react-redux";
import NotLoggedIn from "Components/notLoggedIn";
import main_yachtImg from "assets/Images/bg/main_yacht.jpg";
import cardLogos from "assets/Images/icons/stripLogos.png";
import { CustomRatings } from "Utills/CustomRatings";
import { Button } from "@material-ui/core";
import CustomInput from "Utills/CustomInput/CustomInput";
import { Helmet } from "react-helmet";

const FinalizeBooking = (props) => {
  //
  const [payWithVisa, setPayWithVisa] = useState(false);
  const [formData, setFormData] = useState({
    paymentType: true,
  });
  // id
  let { id } = useParams();
  // user
  let user = props.current_user;
  const [summaryAvail, setSummaryAvail] = useState(false);

  //=================== check if Trip Summary id is available or not ===========================
  // id will be retrieve from Params/URL

  useEffect(() => {
    if (id) {
      setSummaryAvail(true);
    } else {
      setSummaryAvail(false);
    }
  }, [id]);

  // ============== Check user is logged in or not
  if (user && Object.values(user).length > 0) {
    return (
      <div className="tripSummary_page">
         <Helmet>
        <title>Cyan | Finalize Booking</title>
      </Helmet>
        {summaryAvail ? (
          <div className="cs_container">
            <div className="row justify-content-md-between justify-content-center">
              {/* left col */}
              <div className="trip_summary_left_col">
                {/*  */}
                <div className="with-left-border">
                  <h4 className="px-1 ">Your Trip</h4>
                  <div className="mt-3 p-2 mb-2 bg_pr_light rounded">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text-pr fw-bold">Date</div>
                      <Link
                        to={`/yachtDetail/${id}`}
                        className="text-pr fw-bold pe-2"
                      >
                        Edit
                      </Link>
                    </div>
                    <div className="d-flex flex-wrap flex-md-nowrap text-gr">
                      <div>
                      <p className="fw-light">Oct 21th, 2021</p>
                      <p className="fw-light">Oct 21th, 2021</p>
                      </div>
                      <span className="px-md-5  trip_sum_light_card_text">
                        Intraday
                      </span>
                      <span>
                        09:00AM{" "}
                        <span className="text-sec p-2 fw-bold">
                          {" "}
                          <svg
                            width="7"
                            height="12"
                            viewBox="0 0 7 12"
                            fill="none"
                          >
                            <path
                              d="M0.170067 11.8299C-0.0360748 11.6238 -0.054815 11.3012 0.113847 11.0739L0.170067 11.0088L5.17858 6L0.170067 0.991223C-0.0360748 0.785082 -0.054815 0.462503 0.113847 0.235191L0.170067 0.170068C0.376209 -0.0360737 0.698787 -0.0548143 0.926099 0.113847L0.991223 0.170068L6.41058 5.58942C6.61672 5.79556 6.63546 6.11814 6.4668 6.34545L6.41058 6.41058L0.991223 11.8299C0.764467 12.0567 0.396823 12.0567 0.170067 11.8299Z"
                              fill="#3F8BBF"
                            />
                          </svg>
                        </span>{" "}
                        10:00AM
                      </span>
                    </div>
                  </div>
                  <div className="mt-2 p-2 mb-2 bg_pr_light rounded">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text-pr fw-bold">Guest</div>
                      <Link
                        to={`/yachtDetail/${id}`}
                        className="text-pr fw-bold pe-2"
                      >
                        Edit
                      </Link>
                    </div>
                    <div className="d-flex text-gr">
                      <span>6</span>
                    </div>
                  </div>
                </div>
                {/* additional info */}
                <div className="with-left-border mt-md-4 mt-3">
                  <h4 className="px-1">Additional Information</h4>
                  {/*  */}
                  <div className="mt-2 px-3">
                    <h5 className="">Itinerary</h5>
                    <p className="mt-2">
                      <span className="text-pr">
                        The itinerary will be drawn and discussed with a Cyan
                        Representative once your payment is completed.{" "}
                      </span>
                      <br />A suggestion will be sent to go over it. If there
                      are some specific islands you wish to visit we try to
                      include them according to the days you will charter and
                      bearing in mind the distance to get there.
                    </p>
                  </div>
                  {/*  */}
                  <div className="mt-2 px-3">
                    <h5 className="my-2">Provisions</h5>
                    <p className="mt-2">
                      <span className="text-pr">
                        A provisions list is sent to client for on board
                        provisioning.{" "}
                      </span>
                      Items selected will be provided on board by our crew.
                      <br />
                      The provisions are either settled by the{" "}
                      <span className="text-pr"> APA, </span> or by the client
                      cash once provisions are on board upon remittance of all
                      invoices by their captain.
                    </p>
                  </div>
                  {/*  */}
                  <div className="mt-2 px-3">
                    <h5 className="my-2">Cruising</h5>
                    <p className="mt-2">
                      <span className="text-pr">
                        Usually we cruise during day
                      </span>{" "}
                      and dock at Ports allowing you to stroll at night in the
                      traditional villages as well as enjoy traditional taverns
                      or quoted restaurants, that our captains may suggest to
                      them.
                    </p>
                  </div>
                  {/*  */}
                  <div className="mt-2 px-3">
                    <h5 className="my-2">Gratuities</h5>
                    <p className="mt-2">
                      <span className="text-pr">
                        Gratuities are not included in the cost of the charter.{" "}
                      </span>
                      The normal is between 10% & 15% of the base charter rate.
                      As with all service businesses, a gratuity should be given
                      if deserved. Gratuities should be made with cash.
                    </p>
                  </div>
                </div>

                {/* reserve info */}
                <div className="px-3 mt-md-5 mt-3">
                  <h5 className="text-gr">Reservation information</h5>
                  <hr />

                  <div className="d-flex justify-content-start align-items-center">
                    <div className="col-md-2 col-3">Name</div>
                    <CustomInput
                      name="name"
                      placeholder="Enter"
                      blueborder={"true"}
                      // onChange={handleForm}
                      // value={formData?.email}
                      //   wrapperClassName="mb-0"
                    />
                  </div>
                  <div className="d-flex mt-3 justify-content-start align-items-center">
                    <div className="col-md-2 col-3">Surname</div>
                    <CustomInput
                      name="surename"
                      placeholder="Enter"
                      blueborder
                      // onChange={handleForm}
                      // value={formData?.email}
                      //   wrapperClassName="mb-0"
                    />
                  </div>
                  <div className="d-flex mt-3 justify-content-start align-items-center">
                    <div className="col-md-2 col-3">Email</div>
                    <CustomInput
                      name="email"
                      placeholder="Enter"
                      blueborder
                      // onChange={handleForm}
                      // value={formData?.email}
                      //   wrapperClassName="mb-0"
                    />
                  </div>
                  <div className="d-flex mt-3 justify-content-start align-items-center">
                    <div className="col-md-2 col-3">Phone</div>
                    <CustomInput
                      name="phone"
                      placeholder="Enter"
                      blueborder
                      // onChange={handleForm}
                      // value={formData?.email}
                      //   wrapperClassName="mb-0"
                    />
                  </div>
                </div>

                {/*  extras */}
                {/* <div className="with-left-border mt-md-5 mt-4">
                  <h4 className="px-1">Extras</h4>
                  <div className="row m-0 my-2">
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">SUP</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">SUP</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Kayak</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Kayak</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Yacht Slide</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Yacht Slide</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Yacht Golf</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Yacht Golf</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Jetski</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Jetski</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Yoga session</span>
                    </div>
                    <div className="col-sm-6 px-2 my-1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M14.4 0L4.48 10.9067L1.6 8.72H0L4.48 16L16 0H14.4Z"
                          fill="#92B9D5"
                        />
                      </svg>
                      <span className="text-pr px-2 fw-bold">Yoga session</span>
                    </div>
                  </div>
                </div> */}
                {/*  */}
                {/* <div className="with-left-border  mt-md-5 mt-4"> */}
                  {/* <h4 className="px-1">Choose how to pay</h4>
                  <div
                    className={`${
                      payWithVisa ? "border_gray" : " "
                    } trip_summary_payment_box   d-flex justify-content-between align-items-start`}
                  >
                    <div className="col-6">
                      <p className="">Pay in full</p>
                      <p className="fw-normal text-gr">
                        Pay the total now and you are all set
                      </p>
                    </div>
                    <div className="col-6 d-flex justify-content-end align-items-center text-right">
                      <h5 className="fw-bold text-pr py-2 px-2">€ 275.00</h5>
                      <div className={``}>
                        <label
                          htmlFor={"paymentType1"}
                          className="checkbox-button"
                        >
                          <input
                            // checked={formData?.paymentType}
                            checked={!payWithVisa}
                            onChange={(e) => {
                              setPayWithVisa(false);
                            }}
                            // onChange={(e) => {
                            //   setFormData({
                            //     ...formData,
                            //     paymentType: true,
                            //   });
                            // }}
                            type="checkbox"
                            className="checkbox-button__input"
                            id={"paymentType1"}
                            name={"paymentType1"}
                          />
                          <span className="checkbox-button__control"></span>
                        </label>
                      </div>
                    </div>
                  </div> */}
                  {/* <div
                    className={`${
                      formData.paymentType === true ? "border_gray " : " "
                    } trip_summary_payment_box  d-flex justify-content-between align-items-start`}
                  >
                    <div className="col-6">
                      <p className="">Pay a down-payment</p>
                      <p className="fw-normal text-gr">
                        In order to confirm your booking you need to pay at
                        least 35% upfront. Next payment will be schedule exactly
                        one month before your trip starts
                      </p>
                    </div>
                    <div className="col-6 d-flex justify-content-end align-items-center text-right">
                      <h5 className="fw-bold text-pr py-2 px-2">€ 275.00</h5>
                      <div className={``}>
                        <label
                          htmlFor={"paymentType"}
                          className="checkbox-button"
                        >
                          {console.log(formData.paymentType)}
                          <input
                            checked={
                              formData?.paymentType === false ? true : false
                            }
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                paymentType: false,
                              });
                            }}
                            type="checkbox"
                            className="checkbox-button__input"
                            id={"paymentType"}
                            name={"paymentType"}
                          />
                          <span className="checkbox-button__control"></span>
                        </label>
                      </div>
                    </div>
                  </div> */}
                {/* </div> */}
                {/*  */}
                <div className="px-3 mt-md-4">
                  {/* <h4> Pay with</h4>
                  <div className={`trip_summary_payment_box w-max pe-md-5  d-flex justify-content-start align-items-center ${payWithVisa ? " ": " border_gray"}`}>
                    <div className={``}>
                      <label htmlFor={"visa"} className="checkbox-button">
                        <input
                          checked={payWithVisa}
                          type="checkbox"
                          className="checkbox-button__input"
                          onChange={(e) => setPayWithVisa(true)}
                          id={"visa"}
                          name={"visa"}
                        />
                        <span className="checkbox-button__control"></span>
                      </label>
                    </div>
                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                      <rect
                        opacity="0.1"
                        width="50"
                        height="50"
                        rx="12"
                        fill="#92B9D5"
                      />
                      <path
                        d="M25.2186 22.8363C25.1974 24.5079 26.7084 25.4407 27.8466 25.9954C29.016 26.5644 29.4088 26.9293 29.4041 27.4382C29.3954 28.217 28.4713 28.5607 27.6066 28.5741C26.098 28.5975 25.2208 28.1668 24.5234 27.8411L23.98 30.3841C24.6796 30.7065 25.9752 30.9877 27.3186 31C30.4722 31 32.5353 29.4433 32.5465 27.0298C32.5589 23.9666 28.3096 23.7971 28.3387 22.4279C28.3487 22.0128 28.7448 21.5697 29.6129 21.4571C30.0425 21.4002 31.2286 21.3567 32.5734 21.9759L33.1012 19.5155C32.378 19.2521 31.4485 19 30.2913 19C27.3231 19 25.2354 20.5779 25.2186 22.8363ZM38.1727 19.2119C37.5969 19.2119 37.1116 19.5478 36.8951 20.0633L32.3903 30.8193H35.5416L36.1687 29.0862H40.0195L40.3832 30.8193H43.1607L40.737 19.2119H38.1727ZM38.6136 22.3475L39.523 26.7062H37.0324L38.6136 22.3475ZM21.3979 19.2121L18.9139 30.8191H21.9168L24.3996 19.2118H21.3979V19.2121ZM16.9556 19.2118L13.83 27.1124L12.5657 20.3948C12.4173 19.6449 11.8315 19.2119 11.1809 19.2119H6.07156L6 19.549C7.04892 19.7766 8.24067 20.1437 8.96269 20.5365C9.40456 20.7765 9.53056 20.9862 9.67571 21.5564L12.0704 30.8193H15.2437L20.1089 19.2119H16.9556"
                        fill="url(#paint0_linear_781_7912)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_781_7912"
                          x1="23.0843"
                          y1="31.2407"
                          x2="23.4316"
                          y2="18.9165"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#222357" />
                          <stop offset="1" stopColor="#254AA5" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <span className="fw-normal text-gr px-2">....4001</span>
                  </div> */}

                  {/* card pay form */}
                  {payWithVisa &&
                  <div className="card_payment_box d-flex flex-wrap">
                    <div className="col-md-6 col-12 px-2">
                      <CustomInput
                        name="first_name"
                        placeholder="First Name"
                        // onChange={handleForm}
                        // value={formData?.email}
                        //   wrapperClassName="mb-0"
                      />
                    </div>
                    <div className="col-md-6 col-12 px-2">
                      <CustomInput
                        name="last_name"
                        placeholder="Last Name"
                        // onChange={handleForm}
                        // value={formData?.email}
                        //   wrapperClassName="mb-0"
                      />
                    </div>
                    <div className="col-md-9 col-12 px-2">
                      <CustomInput
                        name="card_number"
                        placeholder="Card Number"
                        type="number"
                        // onChange={handleForm}
                        // value={formData?.email}
                        //   wrapperClassName="mb-0"
                      />
                    </div>
                    <div className="col-md-3 col-12 px-2">
                      <CustomInput
                        name="cvv"
                        placeholder="CVV"
                        type="number"
                        // onChange={handleForm}
                        // value={formData?.email}
                        //   wrapperClassName="mb-0"
                      />
                    </div>
                    <div className="col-12 px-2">
                      <CustomInput
                        name="expiry_date"
                        placeholder="Expiry Date"
                        type="number"
                        start_icon={
                          <svg
                            width="30"
                            height="24"
                            viewBox="0 0 30 24"
                            fill="none"
                          >
                            <path
                              d="M21.0156 2.70629e-06C21.6945 -0.00119397 22.2313 0.394608 22.2328 0.922343L22.2344 1.82189C26.6393 2.08096 29.549 4.33343 29.5537 7.7877L29.5711 17.8986C29.5774 21.6647 26.4245 23.982 21.3708 23.988L9.02625 24C4.00411 24.0048 0.811789 21.6324 0.805474 17.8555L0.788097 7.86326C0.781792 4.38621 3.58889 2.13973 7.99372 1.83629L7.99214 0.936736C7.99056 0.409 8.51156 0.0119994 9.20623 0.0119994C9.9009 0.0108 10.4219 0.406602 10.4235 0.934337L10.4251 1.77392L19.8031 1.76432L19.8015 0.924742C19.7999 0.397006 20.3209 0.00120482 21.0156 2.70629e-06ZM21.6597 17.0303H21.644C20.9177 17.0435 20.3351 17.5004 20.3509 18.0522C20.3525 18.6039 20.9382 19.0585 21.6645 19.0704C22.4049 19.0692 23.0049 18.6123 23.0033 18.0486C23.0033 17.4848 22.4018 17.0303 21.6597 17.0303ZM8.65049 17.0315C7.92425 17.0555 7.35588 17.5124 7.35746 18.0642C7.39062 18.6159 7.99056 19.0477 8.7168 19.0225C9.42884 18.9985 9.99562 18.5415 9.96247 17.9898C9.94668 17.4501 9.36095 17.0303 8.65049 17.0315ZM15.1551 17.0255C14.4289 17.0507 13.8621 17.5064 13.8621 18.0582C13.8952 18.6099 14.4952 19.0405 15.2214 19.0165C15.9319 18.9913 16.5002 18.5355 16.4671 17.9826C16.4513 17.4441 15.8656 17.0243 15.1551 17.0255ZM8.6426 12.7136C7.91636 12.7376 7.34957 13.1946 7.35114 13.7463C7.38272 14.298 7.98424 14.7298 8.71049 14.7046C9.42095 14.6806 9.98773 14.2237 9.95458 13.672C9.93879 13.1322 9.35464 12.7124 8.6426 12.7136ZM15.1488 12.6717C14.4226 12.6956 13.8542 13.1526 13.8558 13.7043C13.8873 14.2561 14.4889 14.6866 15.2151 14.6627C15.9256 14.6375 16.4924 14.1817 16.4608 13.63C16.4434 13.0902 15.8593 12.6705 15.1488 12.6717ZM21.6534 12.6776C20.9272 12.6896 20.3588 13.1334 20.3604 13.6851V13.6983C20.3762 14.2501 20.9761 14.6687 21.704 14.6567C22.4144 14.6435 22.9812 14.1865 22.9654 13.6348C22.9323 13.107 22.3623 12.6765 21.6534 12.6776ZM19.8062 3.6114L10.4282 3.62099L10.4298 4.5913C10.4298 5.10824 9.91037 5.51604 9.2157 5.51604C8.52103 5.51724 7.99845 5.11064 7.99845 4.5937L7.99687 3.67017C4.91823 3.90165 3.21471 5.25937 3.21944 7.86087L3.22103 8.23388L27.1239 8.20989V7.7901C27.0561 5.21139 25.332 3.85847 22.2376 3.65697L22.2392 4.58051C22.2392 5.09625 21.704 5.50525 21.0251 5.50525C20.3304 5.50645 19.8078 5.09865 19.8078 4.58291L19.8062 3.6114Z"
                              fill="#1A4D6D"
                            />
                          </svg>
                        }
                        // onChange={handleForm}
                        // value={formData?.email}
                        //   wrapperClassName="mb-0"
                      />
                    </div>
                  </div>}
                </div>
                {/*  */}
                <div className="with-left-border  mt-md-5 mt-4">
                  <h4 className="px-1">Comment</h4>
                  <h6 className="px-1 py-2 text-muted">Message the Host</h6>
                  <p className="pt-2 fw-normal px-2 text-gr">
                    Let the host know why you are booking
                  </p>
                  <div className="boat-desc-wrappper mid-height mt-1 p-0">
                    <textarea
                      //   onChange={handleForm}
                      //   value={formData.description}
                      placeholder="Type..."
                      name="description"
                      className="m-0"
                    />
                    {/* <div className="boat-desc-count d-flex justify-content-between align-items-center mt-2">
                              <span className="text-danger mt-0">
                                {errors?.description?.msg}
                              </span>
                              <span className="text-sec me-auo">
                                {formData?.description?.trim().length}/500
                              </span>
                            </div> */}
                  </div>
                </div>
                {/*  */}
                <div className="with-left-border  mt-md-5 mt-4">
                  <h4 className="px-1">Cancellation policy</h4>
                  {/* <p className="pt-2 fw-normal px-2 text-gr">
                    <span className="text-dark fw-bold">
                      Free cancellation before 3:00 PM on Oct 20th.
                    </span>{" "}
                    After that, cancel before 3:00 PM on Oct 21th get full
                    refund, minus first night and service fee
                  </p> */}
                  <p className="pt-2 fw-light px-2">
                    60% refund up to 30 days before arrival, exluding expenses.
                  </p>
                </div>
                <div className="px-3 mt-4">
                  <hr className="cs_hr" />
                </div>
                {/*  */}
                <div className="d-flex flex-wrap p-3 pt-0">
                  <div className=" pb-3">
                    <svg width="33" height="38" viewBox="0 0 33 38" fill="none">
                      <path
                        opacity="0.2"
                        d="M26.5077 33.2053L22.6172 29.3149V23.5244H24.4267V28.573L27.7743 31.9206L26.5077 33.2053ZM23.5219 16.2863C24.1372 16.2863 24.7343 16.3406 25.3315 16.4311V7.23868H21.7124V12.6672H7.23623V7.23868H3.61719V34.3815H12.0858C11.1677 32.4517 10.7532 30.3208 10.8809 28.1876C11.0086 26.0543 11.6743 23.9881 12.816 22.1816C13.9578 20.3751 15.5383 18.887 17.4103 17.8562C19.2823 16.8254 21.3849 16.2853 23.5219 16.2863ZM14.4743 7.23868C13.4791 7.23868 12.6648 6.42439 12.6648 5.42915C12.6648 4.43391 13.4791 3.61963 14.4743 3.61963C15.4696 3.61963 16.2839 4.43391 16.2839 5.42915C16.2839 6.42439 15.4696 7.23868 14.4743 7.23868Z"
                        fill="#92B9D5"
                      />
                      <path
                        d="M23.5238 19.9048C18.5295 19.9048 14.4762 23.9581 14.4762 28.9524C14.4762 33.9467 18.5295 38 23.5238 38C28.5181 38 32.5714 33.9467 32.5714 28.9524C32.5714 23.9581 28.5181 19.9048 23.5238 19.9048ZM26.5095 33.2048L22.619 29.3143V23.5238H24.4286V28.5724L27.7762 31.92L26.5095 33.2048ZM25.3333 3.61905H19.579C18.819 1.52 16.8286 0 14.4762 0C12.1238 0 10.1333 1.52 9.37333 3.61905H3.61905C1.62857 3.61905 0 5.24762 0 7.2381V34.381C0 36.3714 1.62857 38 3.61905 38H14.6752C13.6047 36.9609 12.7338 35.7342 12.1057 34.381H3.61905V7.2381H7.23809V12.6667H21.7143V7.2381H25.3333V16.4305C26.6181 16.6114 27.8305 16.9914 28.9524 17.5162V7.2381C28.9524 5.24762 27.3238 3.61905 25.3333 3.61905ZM14.4762 7.2381C13.481 7.2381 12.6667 6.42381 12.6667 5.42857C12.6667 4.43333 13.481 3.61905 14.4762 3.61905C15.4714 3.61905 16.2857 4.43333 16.2857 5.42857C16.2857 6.42381 15.4714 7.2381 14.4762 7.2381Z"
                        fill="#3F8BBF"
                      />
                    </svg>
                  </div>
                  <div className="col-md-10 col-12">
                    <h5 className="px-2">
                      Your reservation won’t be confirmed until the host accepts
                      your request (within 24 hours)
                    </h5>
                    <p className="text-gr px-2 fw-normal my-2">
                      your wont be charged until then
                    </p>
                  </div>
                </div>
                {/*  */}
                {/* <div className="mt-md-4 mt-3 with-left-border text-gr">
                  <p>
                    By selecting the button below, I agree to the{" "}
                    <NavLink className="fw-bold text-pr" to="/" target="_blank">
                      {" "}
                      CYAN Rules.{" "}
                    </NavLink>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Donec vestibulum congue dolor nunc amet.
                  </p>
                  <Button
                    component={Link}
                    to={"/confirmBooking/" + id}
                    className="siginin_form_btn mt-3 mb-2 text-white px-5"
                    type="submit"
                  >
                    Finalize
                  </Button>
                </div> */}
                {/* <div className="w-100 py-md-3 py-2 px-4">
                </div> */}
              </div>
              {/* righ col */}
              <div className="trip_summary_right_col">
                <div className="sticky_wrapper mb-3">
                <div className="overAll_trip_summary_card mx-auto">
                  <div className="d-flex trip_summary_card_top">
                    <div className="col-4">
                      <div className="card_image_square_small">
                        <img src={main_yachtImg} alt="CYAN yacht" />
                      </div>
                    </div>
                    <div className="col-8 px-3">
                      <h4>Motorboat Azimut 62</h4>
                      <p className="text-sec pt-2">Crete . Greece</p>
                      <div className="d-flex flex-wrap w-100">
                        <p className="py-2">
                          12 <span className="text-gr"> people .</span>
                        </p>
                        <p className="py-2 px-md-2">
                          1 <span className="text-gr"> horsepower .</span>
                        </p>
                        <p className="py-2 px-md-2">
                          8 <span className="text-gr"> meters</span>
                        </p>
                      </div>
                      <div className="d-flex flex-wrap w-100 py-md-2 py-1">
                        <CustomRatings name="read-only" value={5} readOnly />
                        <p className="px-1">
                          5 <span className="text-gr px-1">( 23 )</span>
                        </p>
                      </div>
                      {/* <div className="d-flex flex-wrap w-100">
                        <p className="py-2 w-50 text-gr">Status</p>
                        <p className="py-2 w-50 fw-normal text-warning">
                          Pending
                        </p>
                      </div> */}
                    </div>
                  </div>
                  <hr className="cs_hr" />
                  <div className="pb-3">
                    <h5>Pricing</h5>
                    <div className="w-75">
                    <hr className="cs_hr" />
                    </div>
                    <div className="py-2 px-2 d-flex flex-wrap">
                      <p className="w-50 py-1">Charter Rate</p>
                      <p className="w-50 py-1 text-right text-gr"> € 200</p>
                      {/*  */}
                      <p className="w-50 py-1">Extras</p>
                      <p className="w-50 py-1 text-right text-gr"> € 200</p>
                      {/*  */}
                      <p className="w-50 py-1">APA</p>
                      <p className="w-50 py-1 text-right text-gr"> € 200</p>
                      {/*  */}
                      <p className="w-50 py-1">Service fee</p>
                      <p className="w-50 py-1 text-right text-gr"> € 200</p>
                      {/*  */}
                      <p className="w-50 py-1">VAT 24%</p>
                      <p className="w-50 py-1 text-right text-gr"> € 200</p>
                      {/* <p className="w-50 py-1">Extras</p>
                      <p className="w-50 py-1 text-right"> € 0</p>
                      <p className="w-50 py-1">Service Fee</p>
                      <p className="w-50 py-1 text-right"> € 75.00</p> */}
                    </div>
                    <hr className="cs_hr" />
                    <div className="py-2 d-flex flex-wrap">
                      <h5 className="w-50 py-1">Total ( EUR )</h5>
                      <h5 className="w-50 fw-bold py-1 text-pr text-right">
                        {" "}
                        € 275.00
                      </h5>
                    </div>
                  </div>
                  <p className="text-center">
                  Payment will be asked later during the booking process
                  </p>
                </div>
                {/* <div className="my-3 mx-auto text-center">
                  <img className="img-fluid mx-auto" src={cardLogos} alt="" />
                </div> */}
                </div>
              </div>

              {/* book now */}

              <div className="mt-md-5 trip_summary_bottom_col pt-3 mx-auto col-md-6 col-12 mt-3 text-gr">
                <p>
                  By selecting the button below, I agree to the{" "}
                  <NavLink className="fw-bold text-pr" to="/" target="_blank">
                    {" "}
                    CYAN Rules.{" "}
                  </NavLink>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  <br />
                  Donec vestibulum congue dolor nunc amet.
                </p>
              </div>
              <div className="text-center trip_summary_bottom_col">
                <Button
                  // component={Link}
                  // to={"/confirmBooking/" + id}
                  className="siginin_form_btn mt-3 d-inline-block text-center mb-2 mx-auto text-white px-5"
                  // type="submit"
                >
                  Book
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div className="container">
            <div className="row">
              <div className="col-12 text-center text-pr">
                <h5 className="py-4">Trip ID not found!!</h5>
                <Button
                  variant="contained"
                  component={Link}
                  to="/"
                  color="primary"
                >
                  Visit Site
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    // This will show when user is not logged in
    return <NotLoggedIn />;
  }
};

// Redux store config
const mapStateToProps = (store) => ({
  current_user: store.current_user,
});

export default connect(mapStateToProps, null)(withRouter(FinalizeBooking));
